<template>
  <div>
    <header class="header">
      <div class="title">
        <div class="logo">
          <img :src="logo" alt="">
          <h1>{{ $t('title') }}</h1>
        </div>
      </div>
      <div class="language">
        <el-button
          style="font-size: 14px;
          font-weight: 700;
          color: #FFF;"
          type="text"
          @click="handleChange">{{ $t('switchLanguage') }}</el-button>
      </div>
    </header>
    <div class="notice-wrapper" v-if="notice">
      <div class="notice-content">{{ notice }}</div>
    </div>
  </div>
</template>

<script>

import logo from '../assets/logo.svg'

export default {
  name: 'global-header',
  data () {
    return {
      logo,
      // notice: '由于平台迁移，将在17:40-18:00时间段内进行维护，期间将无法访问，敬请谅解',
      notice: ''
    }
  },
  methods: {
    handleChange() {
      this.$i18n.locale = this.$i18n.locale === 'zh_CN' ? 'en_US' : 'zh_CN';
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 56px;
  background: #292929;
}
.header:before{
  content: '';
  position: absolute;
  z-index: -2;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 4px;
  border: 1px solid #484848;
  border-left: none;
  background: #333;
}
.title{
  position: relative;
  float: left;
  height: 56px;
}
.title:before{
  content: '';
  position: absolute;
  z-index: -1;
  box-sizing: border-box;
  width: calc(100% + 56px);
  height: calc(100% - 3px);
  border: 1px solid #484848;
  border-top: none;
  margin: 3px 0 0 -28px;
  transform: skewX(-45deg);
  background: #333;
}
.logo{
  min-width: 240px;
  padding: 12px 0 12px 16px;
}
.logo img{
  width: 32px;
  height: 32px;
  margin-right: 16px;
  vertical-align: middle;
}
.logo h1{
  display: inline-block;
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  vertical-align: middle;
  color: #fff;
}
.notice-wrapper{
  position: fixed;
  top: 56px;
  right: 0;
  left: 0;
  width: 100%;
  height: 48px;
  z-index: 1000;
  background: #ffeb3b;
  & .notice-content{
    box-sizing: border-box;
    width: 1000px;
    height: 48px;
    /* padding: 0 24px; */
    margin: 0 auto;
    font-size: 16px;
    text-align: center;
    line-height: 48px;
    color: #e72528;
  }
}
.language {
  float: right;
  margin-right: 24px;
  padding: 11px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalHeader.vue